// pages/integrations/CredentialsPage.jsx — SOUND-709
//
// Was IntegrationsPage: a two-tab shell over Credentials + Pipeline Config, at
// /integrations, labelled "Credentials" for internal users and "Integrations"
// for clients — the same URL under two names.
//
// SOUND-681 (CPO 2026-08-24) had already dissolved the Integrations SECTION,
// moving Rerunner and Billing into Settings and Credentials sideways into
// Resources. That left one non-credential tenant here. Pipeline Config has now
// followed them into the Settings rail, so this route holds only credentials
// and is finally named after what it contains.
//
// No tab shell: a single tab is a decoration that implies a choice nobody has.
import React from "react";
import PageHeader from "components/PageLayout";
import CredentialsTab from "./CredentialsTab";

export default function CredentialsPage() {
  return (
    <div>
      <PageHeader
        title="Credentials"
        subtitle="API and portal credentials, and what uses them."
      />
      <div className="container py-6">
        <CredentialsTab />
      </div>
    </div>
  );
}
